import { render, staticRenderFns } from "./dealer-dialog-header.vue?vue&type=template&id=8aad8da6"
import script from "./dealer-dialog-header.vue?vue&type=script&lang=js"
export * from "./dealer-dialog-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports